module.exports = __webpack_public_path__ + "static/media/speak.2119a5f4.svg";